import React from 'react'
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import cintillo from "../../assets/img/logo_menu_black.png";
import { ADMISION } from './Styles/StylesAdmision';

const ModalListAdmision = (props) => {
    const styles = StyleSheet.create(ADMISION[0]);

    let noName = (nombre) => {
        let nom = nombre;
        if (nombre === null || nombre === undefined) nom = "";
        return nom
    }
    
    let SemCard = ["1er", "2do", "3er", "4to", "5to", "6to", "7mo", "8vo", "9no", "10mo"];

    let Sem = (Semestres) => {
        let num = 0;

        return (
            Semestres.map(option => {
                num++;
                return (
                    <Text key = {num}>
                        {SemCard[option.SEM - 1]} Semestre | Materias: {option.MATERIAS}
                    </Text>
                )
            })
        )

    }

    let estudiants = () => {
        if (props.data.length === 0) return (
            <View style={[styles.row]}>
                <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen estudiantes</Text>
            </View>
        )

        let i = 0;
        return (
            props.data.map(option => {
                i++;

                return(
                    <View key={option.Datos.id} style={[styles.row]}>
                        <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, styles.center]}>{i}</Text>
                        <View style={[styles.colTablaInsc9, styles.bordeCol9, styles.borderTop]}>
                            <Text style ={[styles.font8]}>
                                {`${option.Datos.nacionalidad} ${option.Datos.ci} - ${option.Datos.nombre_1} ${noName(option.Datos.nombre_2)} ${option.Datos.apellido_1} ${noName(option.Datos.apellido_2)}`}
                            </Text>
                            <Text style ={[styles.font8, {color: "#144c4c"}]}>
                                {`Tff 1: ${option.Datos.tlf_cel} | Tlf 2: ${option.Datos.tlf_hab}`}
                            </Text>
                            <Text style ={[styles.font8, {color: "#b41806"}]}>
                                Correo: {option.Datos.email}
                            </Text>
                            <Text style ={[styles.font8]}>
                                Lug. Nacimiento: {(option.Datos.estado_name).toUpperCase()}
                            </Text>
                        </View>
                        <View style={[styles.colTablaIngr1, styles.bordeCol9, styles.borderTop]}>
                            <Text style={[styles.font9, styles.center, {color: "#b41806"}]}>
                                {SemCard[option.SemActual - 1]} Semestre
                            </Text>
                            <Text style={[styles.font9, styles.center]}>
                                {option.Materias}  Materias Inscritas
                            </Text>
                            <View style={[styles.font7, styles.borderTop, {paddingTop: 2, marginTop: 2}]}>
                                {Sem(option.Semestres)}
                            </View>
                        </View>
                    </View>
                )
            })
        )
    }

    return(
        <PDFViewer style={styles.section}>
            <Document title="Listados de Usuarios">
                <Page size="letter" style={styles.body}>
                    <View style={styles.row}>
                        <Image
                            style={[styles.colContent40, styles.logo]}
                            src={cintillo}
                        />
                        <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                            <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={[styles.bordeConstancia, {marginTop: 15, backgroundColor: "#FFF", padding: 4,}]}>
                            <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. {props.titulo.toUpperCase()}</Text>
                            <Text style={[styles.font14, styles.right, {backgroundColor: "#fff", color: "#b41806", marginRight: 12, marginTop: 5}]}>CARRERA: {props.carrera}</Text>
                            <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                                <View style={[styles.row]}>
                                    <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>N°</Text>
                                    <Text style={[styles.colTablaInsc9, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>ESTUDIANTE</Text>
                                    <Text style={[styles.colTablaIngr1, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>SEMESTRE / MATERIAS</Text>
                                </View>
                                {estudiants()}
                            </View>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={[styles.footer]}>
                            <View style={[styles.row]}>
                                <View style={[styles.col6]}>
                                <Text style={[styles.linea3]}></Text>
                                    <Text style={[styles.encabezado2]}>
                                        Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                        C.P.1061  Edo Miranda - Caracas - Venezuela
                                    </Text>
                                    <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                        Telefax: +58 212 9930983 | 9939139 | 9910710.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    )
}

export default ModalListAdmision;


// WEBPACK FOOTER //
// ./src/components/Reportes/ModalListAdmision.jsx